<template>
  <v-row>
    <v-col lg="8" class="mx-auto">
      <v-card flat color="grey lighten-4" class="mb-3">
        <v-card-title class="align-start justify-space-between display-1">
          <span>
            {{ $t('庫存') }}
          </span>
          <div class="font-weight-bold">
            {{ pagination.total }}
          </div>
        </v-card-title>
      </v-card>
      <v-card class="pa-2">
        <v-card-title>
          <v-text-field
            v-model="search"
            :label="$t('快速搜尋')"
            single-line
            hide-details
            append-icon="mdi-magnify"
            @click:append="onSearch"
            @keydown.enter="onSearch"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="items"
          :mobile-breakpoint="0"
          :disable-sort="$vuetify.breakpoint.smAndDown"
          :search="search"
          :options.sync="options"
          :server-items-length="pagination.total"
          :footer-props="footerProps"
        >
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { date } from '../../libs/filters';
import { pagination } from '../../libs/mixins';

export default {
  mixins: [
    pagination,
  ],

  filters: {
    date,
  },

  data() {
    return {
      isLoading: true,
    };
  },

  computed: {
    defaultParameters() {
      return {
        in_stock: true,
      }
    },

    headers() {
      return [
        { text: this.$t('類型') , value: 'type' },
        { text: this.$t('卡號') , value: 'card_no' },
        { text: this.$t('門號') , value: 'phone' },
      ];
    },

    ...mapState('sims', {
      items: 'all'
    }),
  },

  methods: {
    ...mapActions('sims', {
      queryResults: 'get'
    }),
  }
}
</script>
